<template>
    <SliceZone :slices="slices" :components="components" />
    <ProductFooterLogo />
</template>

<script setup lang="ts">
    import {inject, ref} from 'vue';
    import type {PrismicDocument} from '@prismicio/types';
    import {SliceZone} from '@prismicio/vue';
    import {useAsyncData, definePageMeta, useWebsitePageView, createError, useSeoMeta} from '#imports';
    import ProductFooterLogo from '~/components/product/ProductFooterLogo.vue';
    import {usePrismicDocument} from '~/composables/content/usePrismicDocument';
    import {useABTestSlices} from '~/composables/useABTestSlices';
    import {PRISMIC_DOCUMENT} from '~/keys';
    import {components} from '~/slices/components';

    const {fetchDocument} = usePrismicDocument('custom-page', 'product-release');
    const document = inject(PRISMIC_DOCUMENT, ref());

    const {data, error} = await useAsyncData<PrismicDocument>('child-page', () => fetchDocument());
    if (error.value) {
        throw createError(error.value);
    }
    document.value = data.value!;

    const {slices} = useABTestSlices(document.value);

    definePageMeta({
        layout: 'product',
    });

    useSeoMeta({title: document.value?.data?.metaTitle, description: document.value?.data?.metaDescription});

    useWebsitePageView('cms', 'product-release');
</script>
